module.exports = __webpack_public_path__ + "img/order-a-vase.b061a282.png";